import useSWR from 'swr'
import { guardClient } from '../_axios'

/**
 * タスク管理 - カラム一覧取得（タスクを含む）
 * [get]/tasks/columns
 */
export type TaskResponse = {
  id: string
  columnId: string
  companyId: number | null
  title: string
  description: string
  dueDate: string | null
  creator: string
  isSecret: boolean
  position: number
  createdAt: string
  updatedAt: string
}

export type ColumnResponse = {
  id: string
  organizationId: number
  title: string
  position: number
  tasks: TaskResponse[]
  createdAt: string
  updatedAt: string
}

const columnsFetcher = (url: string) => {
  return guardClient
    .get<{ data: ColumnResponse[] }>(url)
    .then((r) => r.data.data)
}

export const useColumns = () => {
  const path = '/tasks/columns'
  const { data, mutate, isLoading } = useSWR(path, columnsFetcher, {
    onErrorRetry: () => {
      return
    },
    suspense: true
  })

  return { data: data ?? [], mutate, isLoading }
}
